import {h, Fragment} from "preact"
import { AutocompleteElement, useCurrencyFormatting } from "@nosto/preact"
import { productImagePlaceholder, hideQuickAdd, showQuickAdd, hoverShowQuickAdd, badgeText } from "../helpers"
import SubmitButton from "./elements/SubmitButton"
import Swatches from "./Swatches"
import Sizes from "./Sizes"
import { useEffect, useMemo } from "preact/hooks"

export default function AutocompleteProduct({product, swatchData}){
    const { format } = useCurrencyFormatting()
    //var { swatchData } = useRelatedData();

    const productColor = useMemo(() => product?.tags1?.find(tag => tag.includes("color:"))?.split(":").pop(), [product]);
    const badge = useMemo(() => product?.tags1?.find(tag => tag.includes("badge"))?.split(":").pop(), [product]);
    const badgeTitle = badgeText(product);
    const styleFamily = useMemo(() => product?.tags1?.find(tag => tag.includes("style-family"))?.split(":").pop(), [product]);
    const gender = useMemo(() => product?.tags1?.find(tag => tag.includes("gender:"))?.split(":").pop(), [product]);
    const productGroup = useMemo(() => product?.tags1?.find(tag => tag.includes("YGroup_")), [product]);
    var relatedProducts = useMemo(() => swatchData.filter(product => product.tags1.includes(productGroup)), [swatchData, product]);
    const shortTitle = useMemo(() => product?.customFields?.find(field => field.key == "custom-gendered_product_title").value , [])
    //var relatedProducts = swatchData.filter(product => product.tags1.includes(productGroup)), [swatchData, products];
    
    return (
        <AutocompleteElement 
            as="li"
            hit={product}
            ariaLabel={`Product ${product.name}`}
            class="ns-product isp_grid_product"
            product_id={product.productId}
            data-product-id={product.productId}
        >
            <div class="product-card collection-common-grid">
                <div class="product_slider_img_main">
                    <div class="product_slider_img">
                        <div class="product-img-wp has_hover">
                            <a href={product.url} class="product-img">
                                <img src={product.imageUrl ?? productImagePlaceholder} alt={product.name} />
                                {product.alternateImageUrls ?
                                    (<div class="hover-img">
                                        <img src={product.alternateImageUrls[0]} alt={product.name} />
                                    </div>)
                                    : (
                                        <div class="hover-img"> <img src={product.imageUrl} alt={product.name} /> </div>
                                    )
                                }
                            </a>
                        </div>
                    </div>
                    {/* {badge && <label class="pc-label has_bagde">{badge}</label>} */}
                    { badgeTitle != "" &&
                        <label className="pc-label has_bagde">
                            <span>
                                {badgeTitle}
                            </span>
                        </label>
                    }
                    <div class="quick-wapper">
                        <a class="q-add ns-d-none ns-d-md-block" tabindex="0" onMouseEnter={(e) => hoverShowQuickAdd(e)}>
                            <span>Quick Add</span>
                        </a>

                        <div style="display: flex; width: 100%; justify-content: end;">
                            <div class="mobile-q-add ns-d-block ns-d-md-none" onClick={(e) => showQuickAdd(e)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                    <path d="M14 6.25281L14 7.75281L-6.55671e-08 7.75281L0 6.25281L14 6.25281Z" fill="black"/>
                                    <rect x="6.25" y="0.00280762" width="1.5" height="14" fill="black"/>
                                </svg>
                            </div>
                        </div>

                        {/* <div class="mobile-q-add ns-d-block ns-d-md-none" onClick={(e) => showQuickAdd(e)}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                                <path d="M14 6.25281L14 7.75281L-6.55671e-08 7.75281L0 6.25281L14 6.25281Z" fill="black"/>
                                <rect x="6.25" y="0.00280762" width="1.5" height="14" fill="black"/>
                            </svg>
                        </div> */}

                        <div class="q-add-label" onMouseLeave={(e) => hoverShowQuickAdd(e)}>
                            <div class="pdp-select-size">
                            <div class="mobile-hide-q-add ns-d-block ns-d-md-none" onClick={(e) => hideQuickAdd(e)}>
                                <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.5858 2.10006L2.10048 10.5853L1.25195 9.73682L9.73723 1.25153L10.5858 2.10006Z" fill="black"/>
                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2.09957 1.41473L10.5849 9.90001L9.73633 10.7485L1.25105 2.26326L2.09957 1.41473Z" fill="black"/>
                                </svg>
                            </div>
                                <ul class={`coll-product-swatch sizes-${product.productId}`}>
                                    {product.skus?.map((sku) => {
                                        const size = sku?.customFields?.find(field => field.key == "size")?.value;
                                        return (
                                            <li class={`swatch-element ${sku.availability == "InStock" ? 'available' : 'soldout'}`}>
                                                <input
                                                    type="radio"
                                                    id={`${product.productId}-${sku.id}`}
                                                    data-product-id={product.productId}
                                                    data-var-id={sku.id}
                                                    name="Size"
                                                    value={size}
                                                    data-main-price={sku.price}
                                                    data-compare-price={sku.price}
                                                />
                                                <label for={`${product.productId}-${sku.id}`}>{shortTitle.toLowerCase().includes("gift card") ? sku.name : size}
                                                {sku.availability == "OutOfStock" && 
                                                    <>
                                                        <img class="crossed-out" src="//www.greats.com/cdn/shop/t/588/assets/sold_out.png?v=87058426774172068061738775364"></img>
                                                        <div class="notify-me">
                                                            <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                                                                <path d="M10.5 5.25C10.5 6.43322 10.5 9.75 10.5 9.75H6H1.59567C1.59567 9.75 1.5 6.70825 1.5 5.25C1.5 2.76472 3.51472 0.75 6 0.75C8.48528 0.75 10.5 2.76472 10.5 5.25Z" stroke="white" stroke-width="1.2"></path>
                                                                <line x1="0.6" y1="9.75599" x2="11.4" y2="9.75599" stroke="white" stroke-width="1.2" stroke-linecap="round"></line>
                                                                <path d="M7.5 9.75019C7.5 10.5786 6.82843 11.2502 6 11.2502C5.17157 11.2502 4.5 10.5786 4.5 9.75019C5.25 9.75 6 9.75 6 9.75C6 9.75 6.75 9.75 7.5 9.75019Z" stroke="white" stroke-width="1.2"></path>
                                                            </svg>
                                                        </div>
                                                    </>
                                                }
                                                </label>
                                            </li>
                                        )
                                    })}
                                </ul>
                                {relatedProducts?.length > 0 && 
                                    <Sizes relatedProducts={relatedProducts} currentProduct={product.productId} />
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pc-detail" data-detail-product="">
              
                    <div class="pc-name-price">
                        <a href={product.url} class="pc-name" tabindex="0">
                            { product?.customFields?.find(field => field.key == "custom-gendered_product_title")?.value ? 
                                (<> {product?.customFields?.find(field => field.key == "custom-gendered_product_title").value} </>) :
                                (gender && styleFamily) ? 
                                    (<>{gender}'s {styleFamily} </>) : <> {product.name} </>
                                }
                        </a>
                        <span class={`pc-price-wp ${product.onDiscount ? 'has_compare_price' : ''}`} data_p_price="">
                            <span class="pc-price" data_compare_price="" style="margin-right: 3px;">
                                {product.onDiscount && <>{format(product.listPrice)}</>}
                            </span>
                            <span class="pc-price-discount" data_main_price="">{format(product.price)}</span>
                        </span>
                    </div>
                    <div class="pc-color-box">
                        <div class="pc-color-count"><i> {productColor} </i></div>
                        {relatedProducts?.length > 0 &&
                            <Swatches product={product} relatedProducts={relatedProducts} />
                        } 
                    </div>
                </div>
            </div>
        </AutocompleteElement>
    )
}